export const GET_PATIENT_INFO = "GET_PATIENT_INFO";
export type GET_PATIENT_INFO = typeof GET_PATIENT_INFO;

export const PUT_PATIENT_INFO = "PUT_PATIENT_INFO";
export type PUT_PATIENT_INFO = typeof PUT_PATIENT_INFO;

export const POST_PATIENT_INFO = "POST_PATIENT_INFO";
export type POST_PATIENT_INFO = typeof POST_PATIENT_INFO;


// WEBPACK FOOTER //
// ./src/sagas/PatientInfo/constant.ts